import { LStoken, LStokenExp } from "CONST";

export const useIsLogged = () => {
  const token = localStorage.getItem(LStoken);
  const tokenEXP = localStorage.getItem(LStokenExp);
  const isLogged = Boolean(token && tokenEXP);

  return { isLogged };
};
